export const TERME_ASYMETRIQUE_default = [
    {
        strike: 1.1,
        cours_a_terme: 1.075
    },
    {
        strike: 1.1,
        cours_a_terme: 1.15
    },
]


// WEBPACK FOOTER //
// ./src/shared/Cotation/chart/data/default/TermeAsymetrique.ts